"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Volume = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "1 0.5 15 15",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M10.191 2.037v11.965a.517.517 0 01-.244.449.5.5 0 01-.563-.035l-4.098-3.188a.25.25 0 01-.095-.197v-6.02a.25.25 0 01.097-.197l4.098-3.187a.5.5 0 01.805.41zM3.941 5.02h-1.75a1 1 0 00-1 1v4a1 1 0 001 1h1.75a.25.25 0 00.25-.25v-5.5a.25.25 0 00-.25-.25zm7.923 1.303a.5.5 0 00-.045.706 1.5 1.5 0 010 1.982.499.499 0 00.595.783.5.5 0 00.155-.121 2.5 2.5 0 000-3.305.5.5 0 00-.706-.045h.002zm2.556-1.636a.5.5 0 10-.745.666 4 4 0 010 5.334.5.5 0 10.745.666 5 5 0 000-6.666z",
  fill: "#ACB3BE"
}));
var _default = exports.default = Volume;